import { ReactNode } from 'react';
import { Sparkles } from 'lucide-react';

interface AiSummaryCardProps {
	title?: string;
	timestamp?: string;
	children: ReactNode;
	footer?: ReactNode;
}

/**
 * Center-pane AI summary card — equivalent to HubSpot's "Breeze record
 * summary". Renders a sparkle header and free-form content; pass an empty
 * placeholder if no summary yet. Wire to an LLM later.
 */
export function AiSummaryCard({ title = 'AI record summary', timestamp, children, footer }: AiSummaryCardProps) {
	return (
		<div className="rounded-lg border bg-card">
			<div className="flex items-center justify-between border-b px-4 py-2.5">
				<div className="flex items-center gap-2 text-sm font-semibold">
					<Sparkles className="h-4 w-4 text-primary" /> {title}
				</div>
				<span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium text-primary uppercase tracking-wide">AI</span>
			</div>
			<div className="px-4 py-3 text-sm leading-relaxed text-foreground">
				{timestamp && <p className="mb-1.5 text-xs text-muted-foreground">Generated {timestamp}</p>}
				{children}
			</div>
			{footer && <div className="border-t px-4 py-2">{footer}</div>}
		</div>
	);
}
